import { Check, MessageSquare, Tag, ChevronDown, ChevronUp } from "lucide-react";

export const ItemRow = ({ item, checked, onToggle, onImage, tag, tagColor = "#FF6B35", labelAction, testId }) => (
  <button
    onClick={onToggle}
    className={`w-full flex items-center gap-3 p-3.5 text-left transition-all rounded-xl ${
      checked
        ? "bg-[#10B981]/5 border border-[#10B981]/15"
        : "bg-white/[0.03] border border-white/[0.08] active:bg-white/[0.06]"
    }`}
    data-testid={testId}
  >
    <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors ${
      checked ? "bg-[#10B981] text-white" : "border-2 border-white/20"
    }`}>
      {checked && <Check className="w-5 h-5" />}
    </div>
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-2 flex-wrap">
        <span className={`text-lg font-bold tracking-wide whitespace-nowrap ${checked ? "text-[#10B981]/70" : item.sku ? "text-[#FFB800]" : "text-white/30 text-sm font-semibold"}`}>
          {item.sku || "No SKU"}
        </span>
        {tag && (
          <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded whitespace-nowrap" style={{ color: tagColor, backgroundColor: `${tagColor}1a` }}>
            {tag}
          </span>
        )}
      </div>
      <p className={`text-sm truncate ${checked ? "text-white/30 line-through" : "text-white/70"}`}>
        {item.title || "Untitled"}
      </p>
      {item.pull_note && (
        <p className="flex items-start gap-1 text-xs text-[#8B5CF6] mt-1" data-testid={`${testId}-note`}>
          <MessageSquare className="w-3 h-3 mt-0.5 flex-shrink-0" />
          <span>{item.pull_note}</span>
        </p>
      )}
      {item.platform && <span className="text-[10px] text-white/30 capitalize">{item.platform}</span>}
    </div>
    {labelAction && (
      <span
        role="button"
        tabIndex={0}
        onClick={(e) => { e.stopPropagation(); labelAction.onClick(); }}
        onKeyDown={(e) => { if (e.key === "Enter") { e.stopPropagation(); labelAction.onClick(); } }}
        className={`flex flex-col items-center justify-center gap-0.5 px-2 py-1.5 rounded-lg border text-[#FF6B35] flex-shrink-0 max-w-[96px] active:bg-[#FF6B35]/20 ${labelAction.open ? "bg-[#FF6B35]/20 border-[#FF6B35]/50" : "bg-[#FF6B35]/10 border-[#FF6B35]/25"}`}
        data-testid={`${testId}-view-label`}
      >
        <span className="flex items-center gap-0.5"><Tag className="w-4 h-4" />{labelAction.open ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}</span>
        <span className="text-[10px] font-semibold leading-tight text-center truncate w-full">{labelAction.name || "Label"}</span>
      </span>
    )}
    {item.pull_image_url && (
      <img
        src={item.pull_image_url}
        alt="Item"
        className="w-14 h-14 rounded-lg object-cover border border-white/10 flex-shrink-0"
        onClick={(e) => { e.stopPropagation(); onImage && onImage(item.pull_image_url); }}
        data-testid={`${testId}-image`}
      />
    )}
  </button>
);
